import {
  API_TYPES,
  type GetWorkerRequirementsResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { type UseGetQueryOptions } from "@src/appV2/api";
import { type AxiosError } from "axios";

import { mergeWorkerRequirementWithIncludedResources } from "../mergeWorkerRequirementWithIncludedResources";
import { type WorkerRequirement } from "../types";
import { useGetWorkerRequirements } from "../useGetWorkerRequirements";

interface UseGetBlockingRequirementsForWorkplacesProps {
  workplaceIds: string[];
  qualifications: string[];
}

export function useGetRequirementsForWorkplaces(
  props: UseGetBlockingRequirementsForWorkplacesProps,
  options: UseGetQueryOptions<GetWorkerRequirementsResponse, AxiosError, WorkerRequirement[]> = {}
) {
  const { workplaceIds, qualifications } = props;

  return useGetWorkerRequirements(
    {
      filter: {
        workplaceIds,
        qualifications,
        requiredForBooking: true,
      },
      include: [API_TYPES.requirements, API_TYPES.requirementMappings],
    },
    {
      select: mergeWorkerRequirementWithIncludedResources,
      ...options,
      enabled: workplaceIds.length > 0 && (options.enabled ?? true),
    }
  );
}
